import React, { useEffect, useState } from "react";
import Cookie from "js-cookie";

import {
  Box,
  Button,
  Flex,
  Heading,
  Modal,
} from "@catchoftheday/cg-components";
import { useEventBus } from "@catchoftheday/state";
import { getCookie } from "@catchoftheday/utilities";

import { TRIGGER_ADULT_MODAL_EVENT, triggerAdultModal } from "./trigger";

type AdultModalProps = {
  adult?: boolean;
};

export const AdultModal = ({ adult = false }: AdultModalProps) => {
  const [open, setOpen] = useState(adult);

  useEffect(() => {
    if (adult) {
      const hasAdultCookie = getCookie("over18", false);
      setOpen(!hasAdultCookie);
    }
  }, [adult]);

  const closeModal = (isAdult: boolean) => {
    if (isAdult) {
      setOpen(false);
      triggerAdultModal({ open: false });
      Cookie.set("over18", "true", {
        expires: 30,
      });
    } else {
      // As the adult modal is only connected to the product spa window.location is needed to redirect to relevant home page.
      window.location.assign("/");
    }
  };

  useEventBus<{ open: boolean }>(TRIGGER_ADULT_MODAL_EVENT, (event) => {
    if (event.payload) {
      const { open } = event.payload;
      setOpen(open);
    }
  });

  return (
    <Modal
      shouldCloseOnOverlayClick={false}
      isOpen={open}
      onRequestClose={() => closeModal(false)}
      contentProps={{ p: 0 }}
      maxWidth={"600px"}
      enableDefaultResponsiveStyles={false}
    >
      <Box
        borderBottom={"1px solid #ddd"}
        backgroundColor={"#f7f7f7"}
        p={"20px"}
      >
        <Heading.h4
          lineHeight={1}
          fontSize={"1.25rem"}
          fontWeight={"600px"}
          paddingRight={"36px"}
          textAlign="left"
          m={0}
        >
          You must be 18+ to view this sale
        </Heading.h4>
      </Box>
      <Box marginBottom={5}>
        <Heading.h4 fontSize={"1.25rem"} textAlign={"center"}>
          Are you over 18 years old?
        </Heading.h4>
        <Flex justifyContent="center">
          <Button
            variant={"error"}
            fontSize={"1rem"}
            textAlign={"center"}
            marginLeft={"10px"}
            marginRight={"10px"}
            onClick={() => closeModal(false)}
          >
            No
          </Button>
          <Button
            variant={"primary"}
            fontSize={"1rem"}
            textAlign={"center"}
            marginLeft={"10px"}
            marginRight={"10px"}
            onClick={() => closeModal(true)}
          >
            Yes
          </Button>
        </Flex>
      </Box>
    </Modal>
  );
};
